import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M22.78 9.257l4.986 5.16a.864.864 0 010 1.182l-4.987 5.16a.796.796 0 01-1.143 0 .864.864 0 010-1.183l3.637-3.762H2.83a.833.833 0 01-.831-.86c0-.43.312-.86.831-.86h22.546l-3.637-3.762a.864.864 0 010-1.182c.208-.215.728-.215 1.04.107z" /></svg>);